import { LANGUAGES, REGIONS } from 'state/intl/types';

export const regionSupportedLanguages = {
  [REGIONS.US]: new Set([LANGUAGES.en]),
  [REGIONS.CA]: new Set([LANGUAGES.fr, LANGUAGES.en]),
};
